// The generated importer waits for CSS as well as JavaScript. Share its whole
// promise so a click during a preload cannot skip Vite's in-flight CSS barrier.
export function createPageLoader<T>(
  importers: Record<string, () => Promise<T>>
) {
  const pages = new Map<string, Promise<T>>()
  const speculative = new Set<string>()
  let failed = false

  function resolve(name: string): Promise<T> {
    const existing = pages.get(name)
    if (existing) return existing
    const importer = importers[name]
    if (!importer) {
      return Promise.reject(
        new Error(`Missing Inertia page component: '${name}.svelte'`)
      )
    }
    const promise = importer().catch((error: unknown) => {
      if (speculative.has(name)) failed = true
      throw error
    })
    pages.set(name, promise)
    return promise
  }

  async function preload(name: string): Promise<void> {
    if (failed) return
    speculative.add(name)
    try {
      await resolve(name)
    } catch {
      // Vite remembers failed CSS dependencies. Recover on the next committed
      // navigation; never refresh a page just because its user focused a link.
      failed = true
    }
  }

  return { resolve, preload, preloadFailed: () => failed }
}
